import { Routes } from '@angular/router';

import {SelectCustomerComponent} from '@app/webshop/field-agent/select-customer.component';
import {BasePermissionDefinition} from '@shared/permission/base-permission-definition';
import {FieldAgentDashboardComponent} from '@app/webshop/field-agent/field-agent-dashboard.component';
import {FieldAgentOrderConfirmationComponent} from '@app/webshop/field-agent/field-agent-order-confirmation.component';
import {FieldAgentOrderSubmittedComponent} from '@app/webshop/field-agent/field-agent-order-submitted.component';
import {FieldAgentPromotionsComponent} from '@app/webshop/field-agent/promotions/field-agent-promotions.component';

export const FieldAgentMappingRoutes: Routes = [
    {
        path: 'select-customer',
        component: SelectCustomerComponent,
        data: { permission: BasePermissionDefinition.Webshop.Customer.CustomerOverview }
    },
    {
        path: 'select-templates',
        component: FieldAgentDashboardComponent,
        data: { permission: BasePermissionDefinition.Webshop.View.Guided }
    },
    {
        path: 'order-confirmation',
        component: FieldAgentOrderConfirmationComponent,
        data: { permission: BasePermissionDefinition.Webshop.View.Guided }
    },
    {
        path: 'order-submitted',
        component: FieldAgentOrderSubmittedComponent,
        data: { permission: BasePermissionDefinition.Webshop.View.Guided }
    },
    {
        path: 'promotion',
        component: FieldAgentPromotionsComponent,
        data: { permission: BasePermissionDefinition.Webshop.View.Guided }
    }
];
